import fastCheckoutBR from './fastCheckout.br';
import fastCheckoutCL from './fastCheckout.cl';
import fastCheckoutCO from './fastCheckout.co';
import fastCheckoutMX from './fastCheckout.mx';

const fastCheckout = {
  BR: fastCheckoutBR,
  CL: fastCheckoutCL,
  CO: fastCheckoutCO,
  MX: fastCheckoutMX,
};

export default fastCheckout;
